// src/tabs/messages/segment-editor/audit-slugs.js — Lot 1 (R4 audit)
//
// Certains messages ne sont PAS rendus par le moteur de templates générique
// (src/lib/template-variables.js) mais par un système DÉDIÉ (ex. le cron
// emit-receipts qui compose le reçu de séjour PDF). Pour ces slugs, l'éditeur
// segmenté doit :
//   • afficher un bandeau explicatif (variables limitées, blocs non interprétés),
//   • restreindre le picker aux variables réellement supportées.
//
// Détection = slug listé OU flag `emits_document` non vide (tout futur document
// émis hors moteur). PUR, 0 I/O.

// Slugs connus rendus hors moteur (recensés à l'audit R4).
export const RENDERED_OUTSIDE_ENGINE_SLUGS = new Set(["recu_sejour_auto"]);

/**
 * `true` si le message est rendu par un système dédié (reçus / documents) et
 * non par le moteur de templates → variables limitées, {#if} non interprétés.
 * @param {{slug?:string, emits_document?:any}|null|undefined} tpl
 */
export function isRenderedOutsideEngine(tpl) {
  if (!tpl) return false;
  if (tpl.emits_document != null && tpl.emits_document !== "") return true;
  return RENDERED_OUTSIDE_ENGINE_SLUGS.has(tpl.slug);
}

// Variables réellement interprétées par le rendu dédié « reçu » (cf.
// api/cron/emit-receipts.js) : uniquement {prenom} et {logement}. Le picker se
// limite à celles-ci pour ces slugs (pas de faux choix qui ne serait pas résolu).
export const RECEIPT_VAR_GROUPS = [
  {
    category: "Reçu (variables supportées)",
    variables: [
      { key: "prenom", label: "Prénom du voyageur" },
      { key: "logement", label: "Nom du logement" },
    ],
  },
];
